module.exports = __webpack_public_path__ + "img/mall03.65f9ef02.png";